module.exports = __webpack_public_path__ + "img/1291f6ffae6b442229e22b161e1dcb3e.png";